/**
 * Confirm "I have my own design" before add to cart (desktop + mobile).
 * Confirm uses product-form.onSubmitHandler (same path as Add to cart).
 *
 * Design file handling:
 * - Prefer a trusted HTTPS CDN URL in properties[Design Upload] (AJAX-safe).
 * - Otherwise keep the real File on the form so product-form can multipart-submit
 *   (Shopify AJAX /cart/add.js cannot store binaries; native /cart/add can).
 * - Never create an empty Design Upload text property (that is what showed in Admin
 *   with no image/link).
 */
(function () {
  var OWN = 'own design';
  var PLEASE = 'please design';
  var dialog = null;
  var adding = false;

  function selectedDesignValue() {
    var fieldsets = document.querySelectorAll('.product-form__input, variant-selects, variant-radios');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend, .form__label');
      var labelText = legend ? legend.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
      if (labelText.indexOf('design') === -1) continue;
      var checked = fieldsets[i].querySelector('input:checked');
      if (checked) return (checked.value || checked.getAttribute('value') || '').trim();
      var select = fieldsets[i].querySelector('select');
      if (select) return (select.value || '').trim();
    }
    var picks = document.querySelectorAll(
      'input[type="radio"][name*="Design"]:checked, input[type="radio"][data-option-name*="Design" i]:checked'
    );
    if (picks.length) return (picks[0].value || '').trim();
    return '';
  }

  function isOwnDesign() {
    return String(selectedDesignValue()).toLowerCase().indexOf(OWN) !== -1;
  }

  function getProductForm() {
    return document.querySelector('product-form.product-form') || document.querySelector('product-form');
  }

  function getForm() {
    var pf = getProductForm();
    return pf ? pf.querySelector('form[action*="/cart/add"], form') : null;
  }

  function getAddButton() {
    var pf = getProductForm();
    return pf ? pf.querySelector('button[type="submit"][name="add"], button.product-form__submit') : null;
  }

  function brandLogoHtml() {
    var script = document.querySelector('script[data-uc-brand-logo]');
    var src = script && script.getAttribute('data-uc-brand-logo');
    if (!src) {
      var headerLogo = document.querySelector('.header__heading-logo, .header__heading-logo-wrapper img');
      if (headerLogo && headerLogo.getAttribute('src')) src = headerLogo.getAttribute('src');
    }
    if (!src) return '';
    var alt = (script && script.getAttribute('data-uc-brand-name')) || '';
    return (
      '<div class="uc-own-design-confirm__logo">' +
      '<img src="' +
      src.replace(/"/g, '') +
      '" alt="' +
      String(alt).replace(/"/g, '') +
      '" width="44" height="44" decoding="async">' +
      '</div>'
    );
  }

  function policyLinkHtml() {
    var script = document.querySelector('script[data-uc-policy-url], script[src*="uc-own-design-confirm"]');
    var href =
      (script && script.getAttribute('data-uc-policy-url')) || '/policies/terms-of-service';
    var label = (script && script.getAttribute('data-uc-policy-label')) || 'Terms of Service';
    return (
      '<a class="uc-own-design-confirm__policy-link" href="' +
      String(href).replace(/"/g, '') +
      '" target="_blank" rel="noopener noreferrer">' +
      String(label).replace(/</g, '') +
      '</a>'
    );
  }

  function isAckChecked() {
    var box = dialog && dialog.querySelector('[data-uc-own-ack]');
    return !!(box && box.checked);
  }

  function syncConfirmEnabled() {
    if (!dialog || adding) return;
    var confirmBtn = dialog.querySelector('[data-uc-own-confirm]');
    if (!confirmBtn) return;
    confirmBtn.disabled = !isAckChecked();
  }

  function ensureDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('div');
    dialog.className = 'uc-own-design-confirm';
    dialog.hidden = true;
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'uc-own-design-confirm-title');
    dialog.innerHTML =
      '<div class="uc-own-design-confirm__backdrop" data-uc-own-close tabindex="-1"></div>' +
      '<div class="uc-own-design-confirm__panel" role="document">' +
      '  <button type="button" class="uc-own-design-confirm__x" data-uc-own-close aria-label="Close">&times;</button>' +
      brandLogoHtml() +
      '  <h2 class="uc-own-design-confirm__title" id="uc-own-design-confirm-title">Before you continue</h2>' +
      '  <div class="uc-own-design-confirm__copy uc-own-design-confirm__copy--desktop">' +
      '    <p class="uc-own-design-confirm__text uc-own-design-confirm__text--lead">Choose this only if your logo/artwork is <strong>final and ready to print</strong>.</p>' +
      '    <p class="uc-own-design-confirm__text">If you still need us to design it, pick <strong>Please design it for me (+$5)</strong>.</p>' +
      '    <p class="uc-own-design-confirm__text">Otherwise we can’t cover design work after you order.</p>' +
      '  </div>' +
      '  <p class="uc-own-design-confirm__text uc-own-design-confirm__copy--mobile">Choose this only if your logo/artwork is <strong>final and ready to print</strong>. If you still need us to design it, pick <strong>Please design it for me (+$5)</strong>. Otherwise we can’t cover design work after you order.</p>' +
      '  <label class="uc-own-design-confirm__ack">' +
      '    <input type="checkbox" data-uc-own-ack>' +
      '    <span>I understand my artwork is print-ready and I agree to the ' +
      policyLinkHtml() +
      '.</span>' +
      '  </label>' +
      '  <div class="uc-own-design-confirm__actions">' +
      '    <button type="button" class="uc-own-design-confirm__btn uc-own-design-confirm__btn--primary" data-uc-own-confirm disabled>' +
      '      <span class="uc-own-design-confirm__btn-label uc-own-design-confirm__btn-label--full">I have my print-ready design</span>' +
      '      <span class="uc-own-design-confirm__btn-label uc-own-design-confirm__btn-label--short">Continue with my design</span>' +
      '    </button>' +
      '    <button type="button" class="uc-own-design-confirm__btn uc-own-design-confirm__btn--secondary" data-uc-own-switch>' +
      '      <span class="uc-own-design-confirm__btn-label uc-own-design-confirm__btn-label--full">Switch to Please design it for me</span>' +
      '      <span class="uc-own-design-confirm__btn-label uc-own-design-confirm__btn-label--short">Switch to design for me (+$5)</span>' +
      '    </button>' +
      '  </div>' +
      '</div>';
    document.body.appendChild(dialog);

    var policyLink = dialog.querySelector('.uc-own-design-confirm__policy-link');
    if (policyLink) {
      policyLink.addEventListener('mousedown', function (event) {
        event.preventDefault();
      });
      policyLink.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        window.open(policyLink.href, '_blank', 'noopener,noreferrer');
      });
    }

    dialog.addEventListener('change', function (event) {
      if (event.target && event.target.matches('[data-uc-own-ack]')) syncConfirmEnabled();
    });

    dialog.addEventListener('click', function (event) {
      if (event.target.closest('.uc-own-design-confirm__policy-link')) return;
      if (adding) return;
      if (event.target.closest('[data-uc-own-close]')) {
        closeDialog();
        return;
      }
      if (event.target.closest('[data-uc-own-confirm]')) {
        if (!isAckChecked()) return;
        addToCart();
        return;
      }
      if (event.target.closest('[data-uc-own-switch]')) {
        switchToPleaseDesign();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && dialog && !dialog.hidden && !adding) closeDialog();
    });

    return dialog;
  }

  function openDialog() {
    var el = ensureDialog();
    var ack = el.querySelector('[data-uc-own-ack]');
    if (ack) ack.checked = false;
    var confirmBtn = el.querySelector('[data-uc-own-confirm]');
    if (confirmBtn) {
      confirmBtn.disabled = true;
      var full = confirmBtn.querySelector('.uc-own-design-confirm__btn-label--full');
      var short = confirmBtn.querySelector('.uc-own-design-confirm__btn-label--short');
      if (full) full.textContent = 'I have my print-ready design';
      if (short) short.textContent = 'Continue with my design';
    }
    el.hidden = false;
    document.body.classList.add('uc-own-design-confirm-open');
  }

  function closeDialog() {
    if (!dialog) return;
    dialog.hidden = true;
    document.body.classList.remove('uc-own-design-confirm-open');
  }

  function setConfirmBusy(busy) {
    if (!dialog) return;
    var confirmBtn = dialog.querySelector('[data-uc-own-confirm]');
    var switchBtn = dialog.querySelector('[data-uc-own-switch]');
    var ack = dialog.querySelector('[data-uc-own-ack]');
    if (confirmBtn) {
      var full = confirmBtn.querySelector('.uc-own-design-confirm__btn-label--full');
      var short = confirmBtn.querySelector('.uc-own-design-confirm__btn-label--short');
      if (busy) {
        if (full) full.textContent = 'Adding…';
        if (short) short.textContent = 'Adding…';
      } else {
        if (full) full.textContent = 'I have my print-ready design';
        if (short) short.textContent = 'Continue with my design';
      }
      confirmBtn.disabled = busy ? true : !isAckChecked();
    }
    if (switchBtn) switchBtn.disabled = !!busy;
    if (ack) ack.disabled = !!busy;
  }

  /** File inputs associated with the add-to-cart form (inside or via form=""). */
  function getFormFileInputs(form) {
    var list = [];
    var seen = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
    function add(el) {
      if (!el || (seen && seen.has(el))) return;
      if (seen) seen.add(el);
      list.push(el);
    }
    if (!form) return list;
    form.querySelectorAll('input[type="file"]').forEach(add);
    if (form.id) {
      document.querySelectorAll('input[type="file"][form="' + form.id + '"]').forEach(add);
    }
    document.querySelectorAll('.onhow-studio-upload-input, input[type="file"]').forEach(function (el) {
      if (el.form === form) add(el);
    });
    return list;
  }

  function isTrustedCdnUrl(value) {
    var v = String(value || '').trim();
    if (!v || v.indexOf('https://') !== 0) return false;
    if (v.indexOf('blob:') === 0 || v.indexOf('data:') === 0) return false;
    return true;
  }

  function getCdnUploadUrl() {
    var source =
      document.getElementById('onhow-upload-url') ||
      document.querySelector('input[type="hidden"][name="properties[Design Upload]"]');
    if (!source) return '';
    return isTrustedCdnUrl(source.value) ? String(source.value).trim() : '';
  }

  function getDesignFile() {
    var candidates = [
      document.getElementById('onhow-studio-upload-hidden'),
      document.getElementById('onhow-studio-upload-input'),
      document.querySelector('.onhow-studio-upload-input'),
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el && el.files && el.files[0] && el.files[0].size > 0) return el.files[0];
    }
    return null;
  }

  function makeCleanup(restore) {
    return function cleanup() {
      restore.forEach(function (item) {
        if (!item || !item.el) return;
        item.el.disabled = item.disabled;
        if (item.name == null) item.el.removeAttribute('name');
        else item.el.setAttribute('name', item.name);
      });
    };
  }

  /**
   * Prepare Design Upload for cart:
   * - CDN URL → text property + disable file inputs (AJAX path)
   * - File → one multipart file input named Design Upload (native /cart/add path)
   */
  function prepareFormForAjaxAdd(form) {
    var restore = [];
    var cdnUrl = getCdnUploadUrl();
    var file = getDesignFile();

    function track(el) {
      if (!el) return;
      restore.push({
        el: el,
        disabled: el.disabled,
        name: el.getAttribute('name'),
      });
    }

    // Drop empty/non-CDN text Design Upload fields so they cannot wipe the file.
    form.querySelectorAll('input[name="properties[Design Upload]"]').forEach(function (el) {
      if (el.type === 'file') return;
      track(el);
      if (cdnUrl && el.type === 'hidden') {
        el.value = cdnUrl;
        el.disabled = false;
        el.setAttribute('name', 'properties[Design Upload]');
      } else {
        el.disabled = true;
        el.removeAttribute('name');
      }
    });

    var urlOutside = document.getElementById('onhow-upload-url');
    if (urlOutside && !form.contains(urlOutside)) {
      track(urlOutside);
      if (cdnUrl) {
        urlOutside.value = cdnUrl;
      } else {
        urlOutside.disabled = true;
        urlOutside.removeAttribute('name');
      }
    }

    if (cdnUrl) {
      var dest = form.querySelector('input[type="hidden"][name="properties[Design Upload]"]');
      if (!dest) {
        dest = document.createElement('input');
        dest.type = 'hidden';
        dest.name = 'properties[Design Upload]';
        dest.id = 'uc-design-upload-prop';
        form.appendChild(dest);
      }
      dest.value = cdnUrl;
      dest.disabled = false;

      getFormFileInputs(form).forEach(function (input) {
        track(input);
        input.disabled = true;
      });
      return { ok: true, mode: 'url', cleanup: makeCleanup(restore) };
    }

    if (file) {
      var fileInput = form.querySelector('#uc-design-upload-file');
      if (!fileInput) {
        fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.id = 'uc-design-upload-file';
        fileInput.name = 'properties[Design Upload]';
        fileInput.accept = 'image/*';
        fileInput.style.display = 'none';
        form.appendChild(fileInput);
      }
      fileInput.name = 'properties[Design Upload]';
      fileInput.disabled = false;
      try {
        var dt = new DataTransfer();
        dt.items.add(file);
        fileInput.files = dt.files;
      } catch (err) {
        return {
          ok: false,
          error: 'Could not attach your design file. Please try again.',
          cleanup: makeCleanup(restore),
        };
      }

      getFormFileInputs(form).forEach(function (input) {
        if (input === fileInput) return;
        track(input);
        input.disabled = true;
      });

      form.setAttribute('enctype', 'multipart/form-data');
      return { ok: true, mode: 'file', cleanup: makeCleanup(restore) };
    }

    return {
      ok: false,
      error: 'Please upload your design file first.',
      cleanup: makeCleanup(restore),
    };
  }

  function addToCart() {
    if (adding) return;
    if (!isAckChecked()) return;
    if (!isOwnDesign()) {
      closeDialog();
      return;
    }

    var pf = getProductForm();
    var form = getForm();
    if (!pf || !form) {
      window.alert('Could not add to cart: product form missing.');
      return;
    }

    var idInput = form.querySelector('[name="id"]');
    if (idInput) idInput.disabled = false;
    if (!idInput || !String(idInput.value || '').trim()) {
      window.alert('Could not add to cart: select all options first.');
      return;
    }

    var prepared = prepareFormForAjaxAdd(form);
    if (!prepared.ok) {
      window.alert(prepared.error || 'Please upload your design file first.');
      prepared.cleanup();
      return;
    }

    adding = true;
    setConfirmBusy(true);
    document.documentElement.setAttribute('data-uc-own-ok', '1');

    var btn = getAddButton();
    if (btn) {
      btn.removeAttribute('aria-disabled');
      btn.removeAttribute('disabled');
    }

    closeDialog();

    var fakeEvt = {
      preventDefault: function () {},
      target: form,
      timeStamp: typeof performance !== 'undefined' ? performance.now() : Date.now(),
    };

    try {
      if (typeof pf.onSubmitHandler === 'function') {
        pf.onSubmitHandler(fakeEvt);
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    } catch (err) {
      console.error('[uc-own-design] add failed', err);
      prepared.cleanup();
      adding = false;
      setConfirmBusy(false);
      document.documentElement.removeAttribute('data-uc-own-ok');
      window.alert('Could not add to cart. Please try again.');
      return;
    }

    // product-form manages its own loading UI; restore inputs after FormData is built
    // (file path navigates away via native submit — cleanup is a no-op after unload)
    setTimeout(function () {
      prepared.cleanup();
      adding = false;
      setConfirmBusy(false);
      document.documentElement.removeAttribute('data-uc-own-ok');
    }, 600);
  }

  function selectPleaseDesign() {
    var fieldsets = document.querySelectorAll('.product-form__input, variant-selects, variant-radios');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend, .form__label');
      var labelText = legend ? legend.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
      if (labelText.indexOf('design') === -1) continue;
      var radios = fieldsets[i].querySelectorAll('input[type="radio"]');
      for (var r = 0; r < radios.length; r++) {
        if (String(radios[r].value || '').toLowerCase().indexOf(PLEASE) !== -1) {
          radios[r].click();
          radios[r].dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
    }
    return false;
  }

  function switchToPleaseDesign() {
    closeDialog();
    selectPleaseDesign();
    setTimeout(function () {
      var notes = document.querySelector('[data-uc-design-notes]');
      var root = notes && notes.closest('[data-uc-design-request]');
      if (root) root.hidden = false;
      if (notes) {
        notes.disabled = false;
        notes.focus();
      }
    }, 150);
  }

  document.addEventListener(
    'click',
    function (event) {
      if (adding) return;
      if (document.documentElement.getAttribute('data-uc-own-ok') === '1') return;
      if (!isOwnDesign()) return;

      var btn = event.target.closest(
        'product-form button[name="add"], product-form button.product-form__submit'
      );
      if (!btn) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      openDialog();
    },
    true
  );
})();
